<template>
  <div class="d-flex align-center my-2">
    <v-select
      v-model="portfolioId"
      :items="groups"
      hide-details
      outlined
      auto-grow
      dense
      item-text="name"
      item-value="id"
      :label="$t('journal.search.criterias.portfolio.input')"
      :rules="rules"
    />
    <v-text-field
      @keydown.enter.prevent="submit"
      :label="$t('journal.search.criterias.score')"
      style="width: 150px; max-width: 150px;"
      class="ml-2 col-3"
      hide-details
      dense
      outlined
      type="number"
      v-model="multiplier"
      :rules="rules"
    />
  </div>
</template>
<script>
import { types } from '@/store/rootTypes';
import { nanoid } from 'nanoid';
import { mapGetters } from 'vuex';
import { criterias } from '../SearchCriteria';

export default {
  name: 'PortfolioBias',
  props: {
    params: {
      type: Object,
      default: undefined,
    },
  },
  data: () => ({
    portfolioId: '',
    multiplier: 0.3,
    id: `${criterias.PORTFOLIO_BIAS}/${nanoid(10)}`,
    rules: [
      v => !!v || 'Ce champs ne peut être vide',
    ],
  }),
  computed: {
    ...mapGetters({
      groups: types.authentication.getters.groups,
    }),
  },

  created() {
    if (this.params !== undefined) {
      const data = this.params.scorings[0].PortfolioBias;
      this.id = data.id;
      this.portfolioId = data.param;
      this.multiplier = Number.parseFloat(data.multiplier);
    }
  },
  methods: {
    submit() {
      this.$emit('submit');
    },
    getCriteria() {
      return {
        scorings: [
          {
            PortfolioBias: {
              param: this.portfolioId,
              multiplier: Number.parseFloat(this.multiplier),
              id: this.id,
            },
          },
        ],
      };
    },
  },
};
</script>
